/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface ConfiguredPayor
 */
export interface ConfiguredPayor {
    /**
     * The payor name
     * @type {string}
     * @memberof ConfiguredPayor
     */
    name: string;
    /**
     * 
     * @type {Array<InsuranceType>}
     * @memberof ConfiguredPayor
     */
    insurance_types: Array<InsuranceType>;
}

/**
 * Check if a given object implements the ConfiguredPayor interface.
 */
export function instanceOfConfiguredPayor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "insurance_types" in value;

    return isInstance;
}

export function ConfiguredPayorFromJSON(json: any): ConfiguredPayor {
    return ConfiguredPayorFromJSONTyped(json, false);
}

export function ConfiguredPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfiguredPayor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'insurance_types': ((json['insurance_types'] as Array<any>).map(InsuranceTypeFromJSON)),
    };
}

export function ConfiguredPayorToJSON(value?: ConfiguredPayor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'insurance_types': ((value.insurance_types as Array<any>).map(InsuranceTypeToJSON)),
    };
}

